module.exports = __webpack_public_path__ + "img/price-1.92332942.jpg";